import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DeviceElement } from '../models/device.model';
import { DeviceService } from '../services/device.service';
import { LanguageService } from '../services/language.service';
import { MenusComponent } from './../menus/menus.component';
import { MatPaginator } from '@angular/material/paginator';
import { TranslocoService } from '@jsverse/transloco';
import { DialogService } from '../services/dialog.service';
import { StorageService } from '../services/storage.service';

const lstDevices: DeviceElement[] = [];

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrl: './devices.component.css'
})

export class DevicesComponent implements OnInit {

  private rowClick$  = new Subject<DeviceElement>();

  // Se comentan las columnas que no se van a mostrar en la tabla porque no tienen un uso claro
  //displayedColumns: string[] = ['id', 'serial_number', 'assigned', 'registered', 'project_name', 'zone_name', 'user_name', 'current_device_state', 'current_firmware_name', 'action'];
  displayedColumns: string[] = ['id', 'serial_number', 'project_name', 'zone_name', 'user_name', 'current_device_state', 'current_firmware_name'];

  dataSource = new MatTableDataSource(lstDevices);

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private router: Router, private deviceService: DeviceService,
              private menusComponent: MenusComponent, private langService:LanguageService,
              private translocoService: TranslocoService, public storageService: StorageService,
              private dialogService: DialogService) { }

  isLoading = false;

  @ViewChild(MatSort)
  sort: MatSort = new MatSort;
  public superAdm = false;

  items: any = [];

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    
    this.translocoService.selectTranslate('device.recordsLabel')
    .subscribe((translatedLabel: string) => {
      this.paginator._intl.itemsPerPageLabel= translatedLabel;
      this.dataSource.paginator = this.paginator;
    });
  }

  ngOnInit(): void {
    this.rowClick$.subscribe(
      row => console.log('[row clicked]', row)
    );
    this.isLoading = true;
    this.loadDevices();
    this.isLoading = false;
  }

  loadDevices():void {
    const req=this.deviceService.getAllDevices(this.storageService.companyId);
    req.subscribe({
      next: (res) => {
        this.items = res;
        this.dataSource.data=this.items.data;
      },
      error: (e) => {
        console.error(e);
        let msg = e.error.message;
      },
    });
  }

  onRowClicked(row: DeviceElement): void {
    this.rowClick$.next(row);
    this.router.navigate(['device'], { queryParams: { id: row.id, companyId: row.company_id } });
  }
  
  anadir(row:any){
    console.log(row)
    this.msgDialog("Dispositivo Activado", row.serial_number,false,"a")
    this.router.navigate(['devices']);
  }
  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Dispositivo',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })

  }

  scanQr() {
    this.dialogService.openScanner().subscribe((result: any) => {
      this.router.navigate(["/qrDevice"], {queryParams: {"serial_number": result.serial_number}})
    })
  }

}
